<template>
  <div>
    <b-modal
      ref="list-chassis-engine-modal"
      hide-footer
      :titleHtml="modalTitle"
      size="lg"
    >
      <b-row class="mb-3">
        <b-col cols="6">
          <b-input
            placeholder="Nhập số khung/ số máy / số seri"
            v-model="search"
            size="sm"
          ></b-input
        ></b-col>
        <b-col cols="1" class="pl-0">
          <b-button
            class="filter-btn"
            variant="primary"
            size="sm"
            @click="fetchData(productId)"
            >Lọc
          </b-button>
        </b-col>
      </b-row>
      <v-form ref="form" lazy-validation>
        <b-table
          :items="listItem"
          :fields="fields"
          bordered
          hover
          :busy="onLoading"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="4"></vcl-table>
          </template>
          <template v-slot:cell(imeiCode)="row">
            <div class="d-flex justify-content-center">
              <span v-text="row.item.imeiCode"></span>
            </div>
          </template>
          <template v-slot:cell(selectChassisReason)="row">
            <div
              class="d-flex flex-column align-items-center"
              v-if="
                !isEmptyEngineNumber(row.item.engineNumber) &&
                row.item.id !== firstValidItemId
              "
            >
              <b-form-select
                v-model="row.item.selectChassisReason"
                :options="[
                  { value: null, text: 'Chọn lý do' },
                  ...Object.keys(SELECT_CHASSIS_REASON).map((key) => ({
                    text: SELECT_CHASSIS_REASON_MAPPING[key],
                    value: SELECT_CHASSIS_REASON[key],
                  })),
                ]"
                size="sm"
                class="w-100"
                @change="
                  (value) => {
                    row.item.selectChassisReason = value;
                  }
                "
              >
              </b-form-select>
              <textarea
                v-model="row.item.selectChassisReasonOther"
                class="form-control mt-2"
                rows="2"
                placeholder="Nhập lý do khác nếu có"
                style="width: 100%"
                v-if="
                  row.item.selectChassisReason === SELECT_CHASSIS_REASON.OTHER
                "
              ></textarea>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div
              v-if="!isEmptyEngineNumber(row.item.engineNumber)"
              class="d-flex justify-content-center"
            >
              <v-icon
                small
                class="text-danger"
                @click="applyChassisEngine(row.item)"
                v-b-tooltip
                title="Áp dụng"
                >mdi-pen</v-icon
              >
            </div>
            <div v-else class="d-flex justify-content-center">
              <v-icon small class="text-info" v-b-tooltip title="Chưa có số máy"
                >mdi-information</v-icon
              >
            </div>
          </template>
        </b-table>

        <b-pagination-nav
          v-model="page"
          class="custom-pagination"
          v-show="totalPages >= 2"
          :number-of-pages="totalPages"
          :link-gen="() => '#'"
          @change="handlePageChange"
          align="right"
          first-class="page-item-first btn btn-icon btn-sm m-1"
          prev-class="page-item-prev btn btn-icon btn-sm m-1"
          next-class="page-item-next btn btn-icon btn-sm m-1 "
          last-class="page-item-last btn btn-icon btn-sm m-1 "
          page-class="btn btn-icon btn-sm border-0 m-1"
        >
          <template v-slot:first-text>
            <span>
              <i class="ki ki-bold-double-arrow-back icon-xs"></i>
            </span>
          </template>

          <template v-slot:prev-text>
            <i class="ki ki-bold-arrow-back icon-xs"></i>
          </template>

          <template v-slot:next-text>
            <i class="ki ki-bold-arrow-next icon-xs"></i>
          </template>

          <template v-slot:last-text>
            <span class="text-info">
              <i class="ki ki-bold-double-arrow-next icon-xs"></i>
            </span>
          </template>
        </b-pagination-nav>
        <b-button
          style="font-weight: 600; width: 70px"
          variant="secondary"
          size="sm"
          @click="hideModal"
          >Hủy</b-button
        >
      </v-form>
    </b-modal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { VclTable } from 'vue-content-loading';
import { convertPrice } from '../../../utils/common';
import {
  EMPTY_ENGINE_NUMBER,
  SELECT_CHASSIS_REASON,
  SELECT_CHASSIS_REASON_MAPPING,
} from '@/utils/enum';
// import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';

export default {
  props: ['billItemId', 'productName', 'storeId', 'productId'],
  data() {
    return {
      modalTitle: '',
      searchText: '',
      listItem: [],
      fields: [
        {
          key: 'chassisNumber',
          label: 'Số khung',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
        },
        {
          key: 'engineNumber',
          label: 'Số máy',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
        },
        {
          key: 'sellingPrice',
          label: 'Giá bán',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'selectChassisReason',
          label: 'Lý do chọn sai FIFO',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
        },
        { key: 'actions', label: '' },
      ],
      search: null,
      onLoading: false,
      totalPages: 1,
      page: 1,
      EMPTY_ENGINE_NUMBER,
      SELECT_CHASSIS_REASON,
      SELECT_CHASSIS_REASON_MAPPING,
      firstValidItemId: null, // Used to store the first valid item ID
    };
  },
  components: {
    VclTable,
    // BPaginationNavCustom,
  },
  watch: {},
  methods: {
    convertPrice,
    handlePageChange(newPage) {
      this.page = newPage;
      this.fetchData(this.productId);
    },
    fetchData(productId) {
      this.onLoading = true;
      const param = {
        search: this.search,
        productId: productId,
        storeId: this.storeId,
        page: this.page,
        limit: 10,
        status: ['NEW'],
        order: 'DESC',
      };
      const paramQuery = {
        params: param,
      };
      ApiService.query('products/chassis-engine', paramQuery)
        .then(({ data }) => {
          this.listItem = data.data.data.map((element) => {
            return {
              id: element.id,
              chassisNumber: element.chassisNumber,
              engineNumber: element.engineNumber,
              // originalPrice: element.originalPrice ? element.originalPrice : 0,
              sellingPrice: element.sellingPrice ? element.sellingPrice : 0,
              selectChassisReason: null,
              selectChassisReasonOther: null,
            };
          });
          this.totalPages = data.data.paginations.totalPages;
          this.page = data.data.paginations.currentPage;
          this.onLoading = false;
          this.firstValidItemId =
            this.listItem.find(
              (item) => !this.isEmptyEngineNumber(item.engineNumber),
            )?.id || null;
        })
        .catch(() => {
          this.onLoading = false;
        });
    },
    showModal: function (productId) {
      this.fetchData(productId);
      this.modalTitle = `<div>
              <span class='d-block' style='font-size: 1.1rem'>Danh sách số khung - số máy sản phẩm: <a class='text-primary'>#${this.productName}</a></span>
              </div>`;
      this.$refs['list-chassis-engine-modal'].show();
    },
    hideModal: function () {
      this.$refs['list-chassis-engine-modal'].hide();
    },
    // applyImei(id) {
    //   this.$emit('applyImei', id);
    //   this.hideModal();
    // },
    applyChassisEngine(data) {
      if (
        data.selectChassisReason === SELECT_CHASSIS_REASON.OTHER &&
        !data.selectChassisReasonOther
      ) {
        this.$bvToast.toast('Vui lòng nhập lý do khác nếu chọn "Lý do khác"', {
          title: 'Thông báo',
          variant: 'danger',
          solid: true,
        });
        return;
      }
      if (data.id !== this.firstValidItemId && !data.selectChassisReason) {
        this.$bvToast.toast('Vui lòng chọn lý do sai FIFO', {
          title: 'Thông báo',
          variant: 'danger',
          solid: true,
        });
        return;
      }
      this.$emit('applyChassisEngine', data);
      this.hideModal();
    },
    isEmptyEngineNumber(engineNumber) {
      if (!engineNumber) return true;

      return (
        engineNumber === this.EMPTY_ENGINE_NUMBER ||
        (engineNumber.startsWith('xx') && engineNumber.endsWith('xx'))
      );
    },
  },
};
</script>
